import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { CheckResponse, createPayrollConsent } from '~/api/payrolls';
import { Button, Typography } from 'antd';
import PayrollPaymentsTable from '~/pages/payrolls/components/PayrollPaymentsTable';
import { Consent, Payroll } from '~/types';
import { ApiError } from '~/types/api/ApiError';

interface VerifyBeneficiaryListProps {
  goNext: (c: { consent: Consent; payroll: Payroll } | ApiError) => void;
  goPrevious: () => void;
  fileData: CheckResponse | undefined;
}

const VerifyBeneficiaryList: FC<VerifyBeneficiaryListProps> = (props) => {
  const { goPrevious, goNext, fileData } = props;
  const [t] = useTranslation('payrolls');
  const [tc] = useTranslation();
  const consent = useMutation(createPayrollConsent, {
    onError: () => {},
  });

  const { isOk, fileId, data } = fileData ?? {};
  const { instructedAmount, recordsTotal } = data ?? {};

  return (
    <>
      <Typography.Title level={4}>{t('List of records')}</Typography.Title>
      {fileData && (
        <>
          <PayrollPaymentsTable data={fileData.data} withScroll processType="create" />
          {isOk && fileId && instructedAmount && recordsTotal ? (
            <Button
              loading={consent.isLoading}
              type="primary"
              className="SendButton"
              onClick={() => {
                consent
                  .mutateAsync({
                    fileId: fileId,
                    amount: instructedAmount,
                    numberOfRecords: recordsTotal,
                  })
                  .then((result) => {
                    goNext(result.data);
                  })
                  .catch(goNext);
              }}
            >
              {tc('continue')}
            </Button>
          ) : (
            <Button type="primary" ghost className="SendButton" onClick={goPrevious}>
              {t('Fix CSV file and re-upload')}
            </Button>
          )}
        </>
      )}
    </>
  );
};

export default VerifyBeneficiaryList;
